import { Node } from "../node";

export class SelectPatientTypeNode extends Node {
  get defaults() {
    return {
      ...super.defaults,
      name: "SelectPatientTypeNode",

      question: undefined,

      returningChoiceText: undefined,
      newChoiceText: undefined,

      returningChoiceTargetNodeId: "continue",
      newChoiceTargetNodeId: "continue",

      selectedPatientType: undefined,
    };
  }

  get currentState() {
    return { selectedPatientType: this.selectedPatientType };
  }

  get context() {
    return { patientType: this.selectedPatientType, selectPatientTypeNodeShown: true };
  }

  get possibleNextNodeIds() {
    return [this.returningChoiceTargetNodeId, this.newChoiceTargetNodeId];
  }

  beforeShow(context) {
    this.selectedPatientType = context.patientType ?? context.defaultPatientType;
  }

  autoAdvance(context) {
    // If we've already shown a SelectPatientTypeNode, we don't need to show another one
    return context.selectPatientTypeNodeShown && context.patientType;
  }

  nextNodeId() {
    if (!this.selectedPatientType) {
      return null;
    }

    return this.selectedPatientType === "returning" ? this.returningChoiceTargetNodeId : this.newChoiceTargetNodeId;
  }

  reset() {
    this.selectedPatientType = undefined;
  }
}
